import styled from 'styled-components';
import Top from '@src/components/Molecules/Aside/Top';
import Bottom from '@src/components/Molecules/Aside/Bottom';
import { devices } from '@src/styles/theme';
import Body from '@src/components/Molecules/Aside/Body';

type Props = {
  isListPage: boolean;
  disabledTop?: boolean;
  disabledBody?: boolean;
  postCommunity?: () => void;
  isActive?: boolean;
};

const Index = ({
  isListPage,
  disabledTop,
  disabledBody,
  postCommunity,
  isActive,
}: Props) => {
  return (
    <Container>
      <TopSection disabledTop={disabledTop}>
        <Top
          isListPage={isListPage}
          postCommunity={postCommunity}
          isActive={isActive}
        />
      </TopSection>
      {/* <BodySection disabledBody={disabledBody}>
        <Body />
      </BodySection> */}
      <Bottom isListPage={isListPage} />
    </Container>
  );
};

const Container = styled.section`
  position: sticky;
  top: 0px;
  right: 0px;
  margin-left: 12px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 100%;
  max-height: 800px;
  min-width: 400px;
  @media ${devices.tablet} {
    display: none;
  }
`;

const TopSection = styled.section<{ disabledTop?: boolean }>`
  display: ${({ disabledTop }) => (disabledTop ? 'none' : 'block')};
`;

const BodySection = styled.section<{ disabledBody?: boolean }>`
  display: ${({ disabledBody }) => (disabledBody ? 'none' : 'block')};
`;

export default Index;
